<template>
  <div>
    <b-form-textarea
      :value="value"
      @input="commitValue($event)"
      rows="3"
      max-rows="6"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import BaseInput from './mixins/BaseInput';
import { PROFESSIONAL_COMMENT } from './_types';

export default {
  mixins: [BaseInput],
  props: {
    inputName: {
      type: String,
      default: PROFESSIONAL_COMMENT,
    },
  },
};
</script>
